/**
 * Save a cookie
 * @param name Name of cookie to save
 * @param value Value of cookie
 * @param daysToLive How long the cookie will persist
 * @param path The path where the cookie is valid. Defaults to root "/"
 */
export function setCookie(name: string, value, daysToLive: number, path = '/') {
  // Encode value in order to escape semicolons, commas, and whitespace
  let cookie = name + '=' + encodeURIComponent(value);

  if (typeof daysToLive === 'number') {
    /* Sets the max-age attribute so that the cookie expires
    after the specified number of days */
    cookie += '; max-age=' + (daysToLive*24*60*60);
  }

  cookie += `; path=${path}`;
  document.cookie = cookie;
}

export function getCookie(cookieName: string) {
  const name = cookieName + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');

  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return null;
}
